const state = {
  currentConferences: [],
  coachingConference: {},
  reloadConf: 0
}

const getters = {
  getCurrentConferences (state) {
    return state.currentConferences
  },
  getCoachingConference (state) {
    return state.coachingConference
  },
  reloadConf (state) {
    return state.reloadConf
  }
}

const mutations = {
  SET_CURRENT_CONFERENCES (state, data) {
    state.currentConferences = data.sort((a, b) => {
      return a.hold - b.hold
    })
  },
  ADD_TO_CURRENT_CONFERENCES (state, data) {
    if (state.currentConferences.length && state.currentConferences.find(e => e.conference_sid === data.conference_sid)) {
      state.currentConferences = state.currentConferences.sort((a, b) => {
        return a.hold - b.hold
      })
      return
    }
    state.currentConferences = state.currentConferences.concat(data).sort((a, b) => {
      return a.hold - b.hold
    })
  },
  UPDATE_CURRENT_CONFERENCES (state, { conferenceSid, data }) {
    const conferenceIndex = state.currentConferences.findIndex(conf => conf.conference_sid === conferenceSid)
    state.currentConferences[conferenceIndex] = {
      ...state.currentConferences[conferenceIndex],
      ...data
    }
    state.reloadConf++
  },
  REMOVE_FROM_CURRENT_CONFERENCES (state, conferenceSid) {
    state.currentConferences = state.currentConferences.filter((conference) => {
      return conference.conference_sid !== conferenceSid
    })
  },
  SET_COACHING_CONFERENCE (state, data) {
    state.coachingConference = data
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
